import { Navigate } from 'react-router-dom'
import { logo } from '@clofo/ui/images'
import { usePageTitle } from '@clofo/ui/hooks'
import { useTranslation } from '@clofo/i18n'

import { OtpForm } from '../components/otp-form'
import { getTfaSession } from '../lib/session'

/**
 * OTP entry after password login for users whose TFA is already configured (tfa_status
 * 'enforced'). Guarded — the legacy pages were not: direct navigation with no pending TFA session
 * returns to the login page, and a first-time-setup session ('enabled') is re-routed to
 * /tfa/confirm, mirroring the legacy auth machine's transitionToTfa action.
 */
export const TfaVerifyPage = () => {
  const { t } = useTranslation()
  usePageTitle(t('login.tfaRequired'))

  const session = getTfaSession()
  if (!session) return <Navigate to='/' replace />
  if (session.status === 'enabled') return <Navigate to='/tfa/confirm' replace />

  return (
    <main className='flex flex-col bg-background items-center justify-center'>
      <img src={logo} alt='Closing Folders' className='my-13 h-15' />
      <div className='w-full max-w-xl px-4'>
        <h1 className='text-xl font-semibold mb-4'>{t('login.tfaRequired')}</h1>
        <p className='mb-6'>{t('login.openYourPhone')}</p>
        <OtpForm />
      </div>
    </main>
  )
}
